<form [formGroup]='formGroup'
      class='widget'>
  <pt-input-label
    *ngIf='label'
    [fontWeightBold]='fontWeightBold'
    [inputId]='id'
    [isRequired]='required'
    [label]='label'
    style='display: contents'
  ></pt-input-label>
  <input [class.is-invalid]='formGroup.invalid'
         [id]='id'
         [max]="maxValue"
         [min]="minValue"
         [ngStyle]="{'width': inputWidth}"
         style="padding-right: 3px"
         aria-describedby='ptWInputHelp'
         autocomplete='off'
         class='form-control form-control-sm'
         formControlName='value'
         placeholder='{{placeholder}}'
         type='number'>
  <small [innerHTML]='help'
         class='form-text text-muted' id='ptWInputHelp_{{id}}'>
  </small>
</form>
